import React from 'react';

import Heading from '../../Components/Heading';
import Button from '../../Components/Button';


const Banner = ({ downloadBroucher }) => {
  return (
    <div className="th-banner-container">
      <Heading className="th-banner-heading" title="300+ HOURS MENTORSHIP" />
      <span className="th-banner-description">
        A one of a kind program, where we kind of incubate a student for 4-6 months, we mentor them one on one, and at the end of it we guarantee them a job.
      </span>

      <div className="th-banner-actions-container">
        <Button onClick={downloadBroucher} text="DOWNLOAD BROCHURE" />
        <Button
          primary
          text="ENROLL TODAY"
          link='#faq-reg-form'
        />
      </div>
    </div>
  );
};

export default Banner;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/Banner.js